// WARNING: DO NOT EDIT. This file is automatically generated.

const awsConfig = {
    "region": "us-east-1",
    "stage": "staging",
    "accountName": "peacock",
    "api_url": "https://h5urnv4g26.execute-api.us-east-1.amazonaws.com/staging/graphql",
    "notifications_api_url": "https://h5urnv4g26.execute-api.us-east-1.amazonaws.com/staging/notifications",
    "run_daily_test_url": "https://kkl1eiaxph.execute-api.us-east-1.amazonaws.com/staging/run-daily-test",
    "sport_highlights_url": "https://lbncvck63vh6vl4wt774t3vdqq.appsync-api.us-east-1.amazonaws.com/graphql",
    "appconfig_url": "https://h5urnv4g26.execute-api.us-east-1.amazonaws.com/staging/getConfig",
    "direct_appconfig_url": "https://8kforpzzid.execute-api.us-east-1.amazonaws.com/staging/getConfig",
		"endpoint_url" : "https://h5urnv4g26.execute-api.us-east-1.amazonaws.com/staging",
    "mgmt_ui_appconfig_dropdown_profile": "mgmt-ui-dropdown-options",
    "mgmt_ui_appconfig_configs_profile": "mgmt-ui-configs",
    "daily-test-game-configs": "daily-testing-configs",
    "leagues": "leagues",
    "aws_project_region": "us-east-1",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_RYginSPsK",
    "aws_user_pools_web_client_id": "31u6og7e50nin0u84f915mncu",
    "oauth": {
        "domain": "spex-mgmt-ui-hosting-staging.auth.us-east-1.amazoncognito.com",
        "scope": [
          "phone",
          "email",
          "profile",
          "openid",
          "aws.cognito.signin.user.admin"
        ],
        "redirectSignIn": "https://mgmt.staging.peacock.aidisco.sky.com",
        "redirectSignOut": "https://mgmt.staging.peacock.aidisco.sky.com",
        "responseType": "code"
    },
    "bitmovinLicenseKey": "2c2acb4c-6bb3-4087-98d2-0d5ecc0a6258",
    "defaultChannelName": "ExternalSLE",
    "licenseAcquisitionEndpointUrl": "https://x0bkopf14a.execute-api.us-east-1.amazonaws.com/staging",
    "arcusLicenseAcquisitionEndpointUrl": "https://ge4dml0c7j.execute-api.us-east-1.amazonaws.com/staging"
};

export default awsConfig;

